//窗口对象
import goingDialog, {
    $dialog,
    __dialogWindow
} from "../../../jsCom/comCtl/goingDialog";
import classes from "./classes";
import goingDialogUtils from "../../../jsCom/comCtl/goingDialog/goingDialogUtils";
import {GoingUtils,AssertUtils} from "goingutils";
class GoingDialog {
    //构造函数
    constructor(options) {
        var curObj = this;
        //默认goingDialog.index 为0 其实就是为了记录GoingDialog的实例对象数量
        curObj.index = ++goingDialog.index;
        //获取当前对象的config信息 curObj.config为(GoingDialog.prototype as any).config
        if (AssertUtils.isNotNull(options.closeWin) && AssertUtils.isFunction(options.closeWin)) {
            curObj.closeWin = options.closeWin;
        }

        curObj.config = goingDialogUtils.extend(
            {},
            curObj.config,
            goingDialog.config,
            options
        );
        //如果document对象存在 则创建对象，如果不存在则执行settimeout
        document.body
            ? curObj.create()
            : setTimeout(function () {
                curObj.create();
            }, 30);
    }
}

//dialog 默认的config信息
GoingDialog.prototype.config = {
    type: 0,
    shade: 0.3,
    fixed: !0,
    move: classes[1],
    title: "提示信息",
    offset: "auto",
    area: "auto",
    closeBtn: 1,
    time: 0,
    zIndex: GoingUtils.maxZindex,
    maxWidth: 360,
    anim: 0,
    isOutAnim: !0,
    icon: -1,
    moveType: 1,
    resize: !0,
    scrollbar: !0,
    tips: 2
};

GoingDialog.prototype.vessel = function (e, backFun) {
    var n = this;
    var a = n.index;
    var r = n.config;
    var s = r.zIndex + a;
    //获取是否显示标题的标志
    var f = "object" == typeof r.title;

    var c = r.maxmin && (1 === r.type || 2 === r.type);
    //判断是否传入了标题配置，如果传入了标题配置 则创建标题时 设置相应的style和标题内容
    var u = r.title
        ? `<div class="layui-layer-title" style="${f ? r.title[1] : ""}">${
            f ? r.title[0] : r.title
            }</div>`
        : "";
    r.zIndex = s;
    var layUiClass =
        classes[0] +
        (" layui-layer-" + goingDialogUtils.type[r.type]) +
        ((0 != r.type && 2 != r.type) || r.shade ? "" : " layui-layer-border") +
        (r.skin || "");
    //获取删除按钮的内容
    var closeBtnText = (function () {
        var e = c
            ? `<a class="layui-layer-min" href="javascript:;"><cite></cite></a><a class="layui-layer-ico layui-layer-max" href="javascript:;"></a>`
            : "";
        return (
            r.closeBtn &&
            (e +=
                '<a class="layui-layer-ico goingicon go-close ' +
                classes[7] +
                " " +
                classes[7] +
                (r.title ? r.closeBtn : 4 == r.type ? "1" : "2") +
                '" href="javascript:;"></a>'),
                e
        );
    })();
    //获取按钮集合的内容
    let btnHtmls = r.btn
        ? (function () {
            var e = "";
            "string" == typeof r.btn && (r.btn = [r.btn]);
            var btnStrs = [];
            for (let t = 0, i = r.btn.length; t < i; t++) {
                btnStrs.push(`<a class="${classes[6] + t}">${r.btn[t]}</a>`);
                // e += `<a class="${classes[6] + t}">${r.btn[t]}</a>`;
            }
            e = btnStrs.reverse().join("");
            return `<div class="${classes[6] +
            " layui-layer-btn-" +
            (r.btnAlign || "")}">${e}</div>`;
        })()
        : "";

    backFun(
        [
            r.shade
                ? `<div class="layui-layer-shade" id="layui-layer-shade${a}" times="${a}" style="${"z-index:" +
                (s - 1) +
                "; "}"></div>`
                : "",
            `<div class="${layUiClass}" id="${classes[0] + a}"
            type="${goingDialogUtils.type[r.type]}"
            times="${a}" showtime="${r.time}"
            conType="${e ? "object" : "string"}"
            style="z-index:${s};width:${r.area[0]};height:${r.area[1] +
            (r.fixed ? "" : ";position:absolute;")}">
             ${e && 2 != r.type ? "" : u}
                 <div id="${r.id || ""}"
                    class="layui-layer-content${(0 == r.type && r.icon !== -1
                ? " layui-layer-padding"
                : "") +
            (3 == r.type ? " layui-layer-loading" + r.icon : "")}">
                    ${(0 == r.type && r.icon !== -1
                ? '<i class="layui-layer-ico layui-layer-ico' +
                r.icon +
                '"></i>'
                : "") + (1 == r.type && e ? "" : r.content || "")}
                 </div>
            <span class="layui-layer-setwin">${closeBtnText}</span>
            ${btnHtmls +
            (r.resize ? '<span class="layui-layer-resize"></span>' : "")}
          </div>`
        ],
        u,
        $('<div class="layui-layer-move"></div>')
    );
    return n;
};

//获取窗口都内容
function getWinContent(
    t,
    classes,
    a,
    iframeId,
    dialogDivId,
    uuid
) {
    //如果包含http 则表示是界面跳转 而不是div的切换
    if (dialogDivId.includes("http")||t.iframe) {
        t.iframe=true;
        t.content =
            '<iframe  scrolling="' +
            (t.content[1] || "auto") +
            '" allowtransparency="true" id="' +
            classes[4] +
            a +
            '" name="' +
            classes[4] +
            a +
            '"  class="layui-layer-load" frameborder="0" src="' +
            t.content[0] +
            '"></iframe>';
        let btnContent =
            '<div class="layui-layer-btn layui-layer-btn-">' +
            '<a  id="cancel_' +
            uuid +
            '"  class="layui-layer-btn1 margin_r_10 common_button common_button_gray  " style="" disableattr="false">'+'取消'+'</a>' +
            '<a id="confirm_' +
            uuid +
            '"  class="layui-layer-btn0 margin_r_10 common_button common_button_emphasize  " style="" disableattr="false">'+'确定'+'</a>' +
            "</div>";
        if (t.bottomBtn) {
            t.content = t.content + btnContent;
        }
    } else {
        t.content = `<div class='dialog-iframe' showBottomBar='${
            t.showBottomBar
            }' id='${iframeId}' targetId='${dialogDivId}'></div>`;
    }
}


//创建窗口对象
GoingDialog.prototype.create = function () {
    var iframeId = GoingUtils.getUUid(12);
    var uuid = GoingUtils.getUUid(12);
    var e = this,
        t = e.config,
        a = e.index,
        s = t.content,
        f = "object" == typeof s,
        $body = $("body");

    if($("#main_router_view").get(0)!=null){
        $body=$("#main_router_view");
    }
    //如果this.id或者元素不存在 则创建该元素
    if (!t.id || !document.getElementById(t.id)) {
        //alert 的type是0
        switch (
            ("string" == typeof t.area &&
            (t.area = "auto" === t.area ? ["", ""] : [t.area, ""]),
            t.shift && (t.anim = t.shift),
            6 == parseInt(goingDialogUtils.ie + "") && (t.fixed = !1),
                t.type)
            ) {
            case 0:
                (t.btn = "btn" in t ? t.btn : goingDialog.btn[0]),
                    goingDialog.closeAll("dialog");
                break;
            case 2:
                s = t.content = f
                    ? t.content
                    : [t.content || "http://layer.layui.com", "auto"];
                var dialogDivId = t.content[0].split("?")[0];
                getWinContent(t, classes, a, iframeId, dialogDivId, uuid);
                break;
            case 3:
                delete t.title,
                    delete t.closeBtn,
                t.icon === -1 && 0 === t.icon,
                    goingDialog.closeAll("loading");
                break;
            case 4:
                f || (t.content = [t.content, "body"]),
                    (t.follow = t.content[1]),
                    (t.content = t.content[0] + '<i class="layui-layer-TipsG"></i>'),
                    delete t.title,
                    (t.tips = "object" == typeof t.tips ? t.tips : [t.tips, !0]),
                t.tipsMore || goingDialog.closeAll("tips");
        }
        //创建容器。
        e.vessel(f, function (n, r, u) {
            $body.append(n[0]);
            let i = $;
            //如果传入的内容不是object 则f为false 如果传入的是object则为true
            f
                ? (function () {
                    2 == t.type || 4 == t.type
                        ? (function () {
                            $body.append(n[1]);
                        })()
                        : (function () {
                            s.parents("." + classes[0])[0] ||
                            (s
                                .data("display", s.css("display"))
                                .show()
                                .addClass("layui-layer-wrap")
                                .wrap(n[1]),
                                i("#" + classes[0] + a)
                                    .find("." + classes[5])
                                    .before(r));
                        })();
                })()
                : $body.append(n[1]);

            //如果.layui-layer-move元素存在 则添加移动div进入body
            i(".layui-layer-move")[0] ||
            $body.append((goingDialogUtils.moveElem = u));
            //将最外层容器对象 赋值给e.layero
            e.layero = i("#" + classes[0] + a);
            if(t.iframe&&t.loading){
                t.loadingId=GoingUtils.showLoading("",$(e.layero));
                //判断是否相应自动关闭loading
                if(t.loadingClose){
                    let iframe=$(e.layero).find("iframe").get(0);
                    if (iframe.attachEvent) {
                        iframe.attachEvent("onload", function() {
                            GoingUtils.closeLoading($(e.layero),t.loadingId);
                        });
                    } else {
                        iframe.onload = function() {
                            GoingUtils.closeLoading($(e.layero),t.loadingId);
                        };
                    }
                }
            }
            t.scrollbar ||
            classes.html.css("overflow", "hidden").attr("layer-full", a);
        }).auto(a);
        //设置边框颜色
        $("#layui-layer-shade" + e.index).css({
            "background-color": t.shade[1] || "#000",
            opacity: t.shade[0] || t.shade
        });
        2 == t.type &&
        6 == parseInt(goingDialogUtils.ie + "") &&
        e.layero.find("iframe").attr("src", s[0]),
            4 == t.type ? e.tips() : e.offset(),
        t.fixed &&
        __dialogWindow.on("resize", function () {
            e.offset(),
            (/^\d+%$/.test(t.area[0]) || /^\d+%$/.test(t.area[1])) && e.auto(a),
            4 == t.type && e.tips();
        }),
        t.time <= 0 ||
        setTimeout(function () {
            goingDialog.close(e.index);
        }, t.time),
            e.move().callback();
        //如果存在动画
        if (classes[t.anim]) {
            var u = "layer-anim " + classes[t.anim];
            e.layero
                .addClass(u)
                .one(
                    "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
                    function () {
                        var i = $;
                       
                        i(this).removeClass(u);
                    }
                );
        }
        t.isOutAnim && e.layero.data("isOutAnim", !0);

        $("#confirm_" + uuid).click(function () {
            let iframe = document.getElementById(classes[4] + a);
            let execFun = iframe.contentWindow["confirmDialog"];
            if (execFun != null) {
                execFun();
            }
        });

        $("#" + iframeId).each(function () {
            var targetId = $(this).attr("targetId");
            var showbottombar = $(this).attr("showbottombar");
            var parentHeight =
                parseFloat(
                    $(this)
                        .closest(".layui-layer")
                        .css("height")
                ) - 41;
            if (showbottombar != null && showbottombar === "true") {
                parentHeight = parentHeight - 40;
            }
            if (t.overflow === false) {
                $("#" + targetId)
                    .show()
                    .appendTo($(this))
                    .css("height", parentHeight)
                    .css("overflow", "hidden");
            } else {
                $("#" + targetId)
                    .show()
                    .appendTo($(this))
                    .css("height", parentHeight)
                    .css("overflow-y", "auto")
                    .css("overflow-x", "hidden");
            }
        });
    }
};
GoingDialog.prototype.auto = function (e) {
    var i = $;
    var t = this,
        a = t.config,
        o = i("#" + classes[0] + e);
    "" === a.area[0] &&
    a.maxWidth > 0 &&
    (goingDialogUtils.ie &&
    parseInt(goingDialogUtils.ie) < 8 &&
    a.btn &&
    o.width(o.innerWidth()),
    o.outerWidth() > a.maxWidth && o.width(a.maxWidth));
    var s = [o.innerWidth(), o.innerHeight()],
        f = o.find(classes[1]).outerHeight() || 0,
        c = o.find("." + classes[6]).outerHeight() || 0,
        u = function (e) {
            (e = o.find(e)),
                e.height(
                    s[1] - f - c - 2 * (0 | parseFloat(e.css("padding-top")))
                );
        };
    switch (a.type) {
        case 2:
            u("iframe");
            break;
        default:
            "" === a.area[1]
                ? a.maxHeight > 0 && o.outerHeight() > a.maxHeight
                ? ((s[1] = a.maxHeight), u("." + classes[5]))
                : a.fixed &&
                s[1] >= __dialogWindow.height() &&
                ((s[1] = __dialogWindow.height()), u("." + classes[5]))
                : u("." + classes[5]);
    }
    return t;
};
GoingDialog.prototype.offset = function () {
    var e = this,
        t = e.config,
        i = e.layero,
        a = [i.outerWidth(), i.outerHeight()],
        o = "object" == typeof t.offset;
    (e.offsetTop = (__dialogWindow.height() - a[1]) / 2),
        (e.offsetLeft = (__dialogWindow.width() - a[0]) / 2),
        o
            ? ((e.offsetTop = t.offset[0]),
                (e.offsetLeft = t.offset[1] || e.offsetLeft))
            : "auto" !== t.offset &&
            ("t" === t.offset
                ? (e.offsetTop = 0)
                : "r" === t.offset
                    ? (e.offsetLeft = __dialogWindow.width() - a[0])
                    : "b" === t.offset
                        ? (e.offsetTop = __dialogWindow.height() - a[1])
                        : "l" === t.offset
                            ? (e.offsetLeft = 0)
                            : "lt" === t.offset
                                ? ((e.offsetTop = 0), (e.offsetLeft = 0))
                                : "lb" === t.offset
                                    ? ((e.offsetTop = __dialogWindow.height() - a[1]), (e.offsetLeft = 0))
                                    : "rt" === t.offset
                                        ? ((e.offsetTop = 0), (e.offsetLeft = __dialogWindow.width() - a[0]))
                                        : "rb" === t.offset
                                            ? ((e.offsetTop = __dialogWindow.height() - a[1]),
                                                (e.offsetLeft = __dialogWindow.width() - a[0]))
                                            : (e.offsetTop = t.offset)),
    t.fixed ||
    ((e.offsetTop = /%$/.test(e.offsetTop)
        ? (__dialogWindow.height() * parseFloat(e.offsetTop)) / 100
        : parseFloat(e.offsetTop)),
        (e.offsetLeft = /%$/.test(e.offsetLeft)
            ? (__dialogWindow.width() * parseFloat(e.offsetLeft)) / 100
            : parseFloat(e.offsetLeft)),
        (e.offsetTop += __dialogWindow.scrollTop()),
        (e.offsetLeft += __dialogWindow.scrollLeft())),
    i.attr("minLeft") &&
    ((e.offsetTop =
        __dialogWindow.height() - (i.find(classes[1]).outerHeight() || 0)),
        (e.offsetLeft = i.css("left"))),
        i.css({
            top: e.offsetTop,
            left: e.offsetLeft
        });
};
GoingDialog.prototype.tips = function () {
    var e = this,
        t = e.config,
        a = e.layero,
        o = [a.outerWidth(), a.outerHeight()],
        r = $dialog(t.follow);
    r[0] || (r = $dialog("body"));
    var s = {
            width: r.outerWidth(),
            height: r.outerHeight(),
            top: r.offset().top,
            left: r.offset().left
        },
        f = a.find(".layui-layer-TipsG"),
        c = t.tips[0];
    t.tips[1] || f.remove(),
        (s.autoLeft = function () {
            s.left + o[0] - __dialogWindow.width() > 0
                ? ((s.tipLeft = s.left + s.width - o[0]),
                    f.css({
                        right: 12,
                        left: "auto"
                    }))
                : (s.tipLeft = s.left);
        }),
        (s.where = [
            function () {
                s.autoLeft(),
                    (s.tipTop = s.top - o[1] - 10),
                    f
                        .removeClass("layui-layer-TipsB")
                        .addClass("layui-layer-TipsT")
                        .css("border-right-color", t.tips[1]);
            },
            function () {
                (s.tipLeft = s.left + s.width + 10),
                    (s.tipTop = s.top),
                    f
                        .removeClass("layui-layer-TipsL")
                        .addClass("layui-layer-TipsR")
                        .css("border-bottom-color", t.tips[1]);
            },
            function () {
                s.autoLeft(),
                    (s.tipTop = s.top + s.height + 10),
                    f
                        .removeClass("layui-layer-TipsT")
                        .addClass("layui-layer-TipsB")
                        .css("border-right-color", t.tips[1]);
            },
            function () {
                (s.tipLeft = s.left - o[0] - 10),
                    (s.tipTop = s.top),
                    f
                        .removeClass("layui-layer-TipsR")
                        .addClass("layui-layer-TipsL")
                        .css("border-bottom-color", t.tips[1]);
            }
        ]),
        s.where[c - 1](),
        1 === c
            ? s.top - (__dialogWindow.scrollTop() + o[1] + 16) < 0 && s.where[2]()
            : 2 === c
            ? __dialogWindow.width() - (s.left + s.width + o[0] + 16) > 0 ||
            s.where[3]()
            : 3 === c
                ? s.top -
                __dialogWindow.scrollTop() +
                s.height +
                o[1] +
                16 -
                __dialogWindow.height() >
                0 && s.where[0]()
                : 4 === c && o[0] + 16 - s.left > 0 && s.where[1](),
        a.find("." + classes[5]).css({
            "background-color": t.tips[1],
            "padding-right": t.closeBtn ? "30px" : ""
        }),
        a.css({
            left: s.tipLeft - (t.fixed ? __dialogWindow.scrollLeft() : 0),
            top: s.tipTop - (t.fixed ? __dialogWindow.scrollTop() : 0)
        });
};
GoingDialog.prototype.move = function () {
    //移动元素 为..layui-layer-title元素
    var e = this,
        t = e.config,
        a = $(document),
        s = e.layero,
        moveEl = s.find(t.move),
        resizeEl = s.find(".layui-layer-resize"),
        c = {};

    t.move && moveEl.css("cursor", "move");
    //注册标题点击down的按钮
    moveEl.on("mousedown", function (e) {
        e.preventDefault();
        //如果选中标题 按下鼠标 则给c对象设置moveStart为true 表示可以移动。
        t.move &&
        ((c.moveStart = !0),
            (c.offset = [
                e.clientX - parseFloat(s.css("left")),
                e.clientY - parseFloat(s.css("top"))
            ]),
            goingDialogUtils.moveElem.css("cursor", "move").show());
    });
    //注册resize元素 点击down事件
    resizeEl.on("mousedown", function (e) {
        //如果是选中resize元素 并且按下鼠标时 则给c对象设置resizeStart 为true 表示开始修改窗口的大小
        e.preventDefault(),
            (c.resizeStart = !0),
            (c.offset = [e.clientX, e.clientY]),
            (c.area = [s.outerWidth(), s.outerHeight()]),
            goingDialogUtils.moveElem.css("cursor", "se-resize").show();
    });
    //注册document 鼠标移动事件
    a.on("mousemove", function (event) {
        //如果开始移动的标识为true时 则修改的时left 和top大小
        if (c.moveStart) {
            var a = event.clientX - c.offset[0],
                o = event.clientY - c.offset[1],
                l = "fixed" === s.css("position");
            if (
                (event.preventDefault(),
                    (c.stX = l ? 0 : __dialogWindow.scrollLeft()),
                    (c.stY = l ? 0 : __dialogWindow.scrollTop()),
                    !t.moveOut)
            ) {
                var f = __dialogWindow.width() - s.outerWidth() + c.stX,
                    u = __dialogWindow.height() - s.outerHeight() + c.stY;
                a < c.stX && (a = c.stX),
                a > f && (a = f),
                o < c.stY && (o = c.stY),
                o > u && (o = u);
            }
            s.css({left: a, top: o});
        }
        //如果开始修改大小标识为true 则修改的时width 和height
        if (t.resize && c.resizeStart) {
            var aH = event.clientX - c.offset[0],
                oH = event.clientY - c.offset[1];
            event.preventDefault(),
                goingDialog.style(e.index, {
                    width: c.area[0] + aH,
                    height: c.area[1] + oH
                }),
                (c.isResize = !0),
            t.resizing && t.resizing(s);
        }
    }).on("mouseup", function () {
        //document 鼠标弹起来按钮事件
        //如果是拖动位置
        c.moveStart &&
        (delete c.moveStart,
            (goingDialogUtils).moveElem.hide(),
        t.moveEnd && t.moveEnd(s));
        //如果是修改大小
        c.resizeStart &&
        (delete c.resizeStart, (goingDialogUtils).moveElem.hide());
    });
    return e;
};
GoingDialog.prototype.callback = function () {
    var curObj=this;
    function e() {
        var e = a.cancel && a.cancel(t.index, n);
        e === !1 || goingDialog.close(t.index);
        if(curObj.closeWin!=null&&AssertUtils.isFunction(curObj.closeWin)){
            curObj.closeWin();
        }
    }

    var t = this,
        n = t.layero,
        a = t.config;
    t.openLayer(),
    a.success &&
    (2 == a.type
        ? n.find("iframe").on("load", function () {
            a.success(n, t.index);
        })
        : a.success(n, t.index)),
    6 == parseInt(goingDialogUtils.ie + "") && t.IE6(n),
        n
            .find("." + classes[6])
            .children("a")
            .on("click", function () {
                //排除点击了取消  确定按钮
               
                if ($(this).hasClass("common_button_emphasize")) {
                    return void 0;
                }
                let i = $;
               
                var e = i(this).index();
                if (1 === e)
                    a.yes
                        ? a.yes(t.index, n)
                        : a.btn1
                        ? a.btn1(t.index, n)
                        : goingDialog.close(t.index);
                else {
                    var o = a["btn" + (e + 1)] && a["btn" + (e + 1)](t.index, n);
                    o === !1 || goingDialog.close(t.index);
                }
            }),
        n.find("." + classes[7]).on("click", e),
    a.shadeClose &&
    window
        .$dialog("#layui-layer-shade" + t.index)
        .on("click", function () {
            goingDialog.close(t.index);
        }),
        n.find(".layui-layer-min").on("click", function () {
            var e = a.min && a.min(n);
            e === !1 || goingDialog.min(t.index, a);
        }),
        n.find(".layui-layer-max").on("click", function () {
           
            $dialog(this).hasClass("layui-layer-maxmin")
                ? (goingDialog.restore(t.index), a.restore && a.restore(n))
                : (goingDialog.full(t.index, a),
                    setTimeout(function () {
                        a.full && a.full(n);
                    }, 100));
        }),
    a.end && (goingDialogUtils[t.index] = a.end);
};
GoingDialog.prototype.openLayer = function () {
    var e = this;
    (goingDialog.zIndex = e.config.zIndex),
        (goingDialog.setTop = function (e) {
            var t = function () {
                goingDialog.zIndex++,
                    e.css("z-index", goingDialog.zIndex + 1);
            };
            return (
                (goingDialog.zIndex = parseInt(e[0].style.zIndex)),
                    e.on("mousedown", t),
                    goingDialog.zIndex
            );
        });
};

export default GoingDialog;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/comCtl/goingDialog/goingDialog.js